export function metaAuth(routers) {
  return routers.map((route) => {
    if (!route.meta) {
      route.meta = {}
    }
    if (route.meta.auth === 'any') {
      route.meta.auth = undefined
    } else if (route.meta.auth === undefined) {
      route.meta.auth = true
    }
    return route
  })
}
